// styles
import styled from 'styled-components';

const SoFormPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 16px 8px;
  gap: 16px;
  background: var(--white);
  border-left: 4px solid var(--grey300);
  border-radius: 4px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  width: 100%;
`;

export default SoFormPanel;
